export default __webpack_public_path__ + "static/media/libraryAllBook.cddfdba0.png";